<!doctype html>
<html lang="es-mx" dir="ltr" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <title></title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table, td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
  <noscript>
  <xml>
  <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
  </o:OfficeDocumentSettings>
  </xml>
  </noscript>
  <![endif]-->
  <!--[if lte mso 11]>
  <style type="text/css">
    .mj-outlook-group-fix { width:100% !important; }
  </style>
  <![endif]-->


  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }

      .mj-column-per-75 {
        width: 75% !important;
        max-width: 75%;
      }

      .mj-column-per-25 {
        width: 25% !important;
        max-width: 25%;
      }

      .mj-column-per-50 {
        width: 50% !important;
        max-width: 50%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    .moz-text-html .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    .moz-text-html .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }

    .moz-text-html .mj-column-per-50 {
      width: 50% !important;
      max-width: 50%;
    }
  </style>
  <style type="text/css">
    [owa] .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    [owa] .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    [owa] .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }

    [owa] .mj-column-per-50 {
      width: 50% !important;
      max-width: 50%;
    }
  </style>

  <style type="text/css">
  </style>
  <style type="text/css">
  </style>

</head>
<body style="word-spacing:normal;background-color:transparent;">


  <div style="background-color:transparent;" role="main" lang="en-US" dir="ltr">


    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 25px 0px 25px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">Para leer este correo electrónico en un navegador, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/email-sp"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px">haga clic aquí</span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">To read this email in a browser </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/email-en"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px">click here</span></a></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:450px;" ><![endif]-->

              <div class="mj-column-per-75 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 0px 0px 0px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: right; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Compartir Este Acuerdo</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td><td class="" style="vertical-align:bottom;width:150px;" ><![endif]-->

              <div class="mj-column-per-25 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="right" style="font-size:0px;padding:0px 0px 5px 0px;word-break:break-word;">


                        <!--[if mso | IE]><table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3B5998;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="http://www.facebook.com/share.php?u=https%3A%2F%2Fwww.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on Facebook" height="25" src="https://static.mailjet.com/ico-social/facebook.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0077B5;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on LinkedIn" height="25" src="https://static.mailjet.com/ico-social/linkedin.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>

                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0F141A;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://twitter.com/intent/tweet?text=Did%20you%20buy%20a%20Google-Made%20Device%20that%20uses%20the%20Google%20Assistant%3F%20Or%20did%20the%20Google%20Assistant%20record%20your%20private%20conversations%3F%20You%20could%20be%20eligible%20for%20money%20from%20a%20%2468%20million%20settlement.%20Learn%20more%20at%20www.GoogleAssistantPrivacyLitigation.com." target="_blank">
                                          <img alt="Share this Settlement on X (Twitter)" height="25" src="https://static.mailjet.com/ico-social/twitter-x.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td></tr></table><![endif]-->


                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px 10px 25px;padding-top:10px;padding-bottom:10px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:20px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;">
                          <h1 class="text-build-content" style="margin-top: 10px">
                            <span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:18px">
                              <strong>Acuerdo de Litigio de Privacidad de Google Assistant</strong>
                            </span>
                          </h1><p class="text-build-content" style="margin: 10px 0;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">¿Compró un dispositivo fabricado por Google o fueron sus comunicaciones grabadas por Google Assistant como resultado de una Activación Falsa o divulgadas a un proveedor externo de revisión?</span></p><p class="text-build-content" style="margin: 10px 0; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">Podría ser elegible para recibir dinero de un acuerdo de demanda colectiva de $68 millones</span></p>
                        </div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:299px;" ><![endif]-->

              <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 25px 10px 25px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/faq" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px 10px 25px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><b>Más información</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td><td class="" style="vertical-align:middle;width:299px;" ><![endif]-->

              <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 25px 10px 25px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com\login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px 10px 25px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><b>Presentar una Reclamación</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:11px;">UN TRIBUNAL ORDENÓ ESTE AVISO</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Es posible que reúna los requisitos para recibir un pago derivado de un acuerdo con los demandados Google LLC y Alphabet Inc. ("Google") en una demanda colectiva. La demanda alega que Google infringió la ley y sus propias políticas de privacidad en relación con el funcionamiento del Asistente de Google. Google niega todas las acusaciones formuladas en la demanda y que haya realizado ninguna acción indebida o ilegal. El Tribunal no se ha pronunciado con respecto a sobre quién tiene razón o si Google hizo algo incorrecto. &nbsp;El Tribunal de Distrito de los Estados Unidos para el Distrito Norte de California ha aprobado este aviso.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px"><b>CONSULTE EL </b></span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/notice"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px"><b>AVISO COMPLETO</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px"><b> QUE SE ENCUENTRA EN EL SITIO WEB DEL ACUERDO,</b></span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px"><b>WWW.GOOGLEASSISTANTPRIVACYLITIGATION.COM</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px"><b>,</b></span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px"><b>PARA OBTENER INFORMACIÓN MÁS DETALLADA SOBRE EL ACUERDO.</b></span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:#edf6fc;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>¿Estoy incluido?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><i><b>	</b></i><b>Usted es miembro del</b><i><b> Grupo de Compradores Demandantes </b></i><b>si es </b>un Usuario que compró un Dispositivo Fabricado por Google en los Estados Unidos o sus territorios entre el 18 de mayo de 2016 y el 19 de marzo de 2026.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>Usted es miembro del </b><i><b>Grupo de Demandantes por Privacidad</b></i><b> si es</b> un Usuario del Asistente de Google o fue miembro del Hogar de un Usuario entre el 18 de mayo de 2016 y el 19 de marzo de 2026, y sus comunicaciones fueron grabadas u obtenidas de otro modo por el Asistente de Google como resultado de una Aceptación Errónea o reveladas a cualquier proveedor de revisión externo. &nbsp;</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;">
                          <ul>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                Los "Usuarios" son personas que residen en los Estados Unidos o sus territorios cuyas cuentas de Google estuvieron asociadas a al menos un dispositivo compatible con el Asistente de Google durante el periodo de la demanda colectiva;
                              </span>
                            </li>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                "Hogar" es un grupo de personas que comparten una vivienda común;
                              </span>
                            </li>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                "Dispositivos Compatibles con el Asistente de Google" son dispositivos que vienen con el Asistente de Google preinstalado o en los que se puede descargar el Asistente de Google;
                              </span>
                            </li>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                "Dispositivos Fabricados por Google" son Dispositivos Compatibles con el Asistente de Google fabricados y vendidos por Google, ya sea directamente o a través de minoristas externos, incluidos los propios altavoces inteligentes para el hogar de Google (Google Home, Home Mini y Home Max); pantallas inteligentes (Google Nest Hub y Nest Hub Max); y teléfonos inteligentes Pixel;
                              </span>
                            </li>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                "Aceptación Errónea" es una situación en la que un Dispositivo Compatible con el Asistente de Google graba y transmite datos de audio a los servidores de Google porque se ha detectado una Palabra de Activación, aunque dicha palabra no se haya pronunciado; y &nbsp;
                              </span>
                            </li>
                            <li style="line-height:20px;">
                              <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                                "Palabra de Activación" es una palabra o frase (como "OK, Google" o "Hey, Google") que puede utilizarse para activar el Asistente de Google en determinados dispositivos compatibles con el Asistente de Google.
                              </span>
                            </li>
                          </ul>
                        </div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Ciertas personas quedan excluidas de los Grupos de Demandantes. La lista de personas excluidas está disponible </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>AQUÍ</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Si usted es miembro de uno o de ambos Grupos de Demandantes, entonces, según los términos del Acuerdo, tiene derecho a presentar un Formulario de Reclamación para recibir un pago si el Tribunal aprueba el Acuerdo y este se convierte en definitivo. El mero hecho de haber recibido este aviso no implica necesariamente que sea miembro de uno o de ambos Grupos de Demandantes; podría ser miembro de uno (o de ninguno) de los Grupos de Demandantes. Lea atentamente cada definición y consulte la información adicional en el sitio web del Acuerdo, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">, para determinar si es miembro de alguno de los Grupos de Demandantes o de ambos.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#edf6fc" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#edf6fc;background-color:#edf6fc;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#edf6fc;background-color:#edf6fc;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>¿Qué se establece en el Acuerdo?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Google ha acordado pagar $68,000,000 a un Fondo del Acuerdo. El Fondo Neto del Acuerdo (es decir, el Fondo del Acuerdo menos los costes de notificación y administración, los honorarios de depósito en garantía, los impuestos, los gastos fiscales y cualquier honorario y gasto de abogados aprobado por el Tribunal, así como las indemnizaciones por servicios prestados a los Demandantes) se utilizará para pagar a los Miembros del Grupo de Demandantes que presenten un Formulario de Reclamación válido y dentro del plazo establecido.&nbsp;</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>¿Cuáles son los pagos previstos?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">En este momento, se desconoce cuánto recibirá cada Miembro del Grupo de Demandantes que presente una reclamación válida. El dinero se pagará proporcionalmente a los Miembros del Grupo de Demandantes que cumplan los requisitos, de acuerdo con el Plan de Asignación propuesto, que puede consultarse </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/court-documents"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>AQUÍ</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>¿Cómo presento una Reclamación?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>Para recibir un pago, debe completar y enviar a tiempo un Formulario de Reclamación válido antes del 27 de agosto de 2026</b>. &nbsp;Puede completar y enviar un Formulario de Reclamación electrónico en línea en el Sitio Web del Acuerdo, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">, o por correo postal a la dirección que figura en el Formulario de Reclamación, <b>con matasellos de fecha no posterior al 27 de agosto de 2026</b>. &nbsp;Puede obtener un Formulario de Reclamación en el Sitio Web del Acuerdo o llamando al 1-877-411-4704.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="center" vertical-align="middle" style="background:transparent;font-size:0px;padding:0px 25px 10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 15px 10px 15px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 15px 10px 15px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><b>PRESENTAR UNA RECLAMACIÓN</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Los Formularios de Reclamación deben ser presentados individualmente por cada Miembro del Grupo de Demandantes y no por un tercero, salvo en el caso de los padres o tutores que presenten un Formulario de Reclamación en nombre de un Miembro del Grupo de Demandantes menor de edad. Se rechazarán los Formularios de Reclamación presentados en masa. El Formulario de Reclamación requiere que confirme o actualice su información de contacto actual y que confirme bajo juramento que es miembro de uno de los dos Grupos de Demandantes.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Puede utilizar el ID único y el PIN que figuran en la parte superior de este correo electrónico para completar su Formulario de Reclamación y confirmar y actualizar su información de contacto.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Si no completa y envía un Formulario de Reclamación válido, no recibirá ningún pago.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;">
                          <p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>¿Cuáles son mis derechos?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0;">
                            <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Si está incluido en el Acuerdo y no hace nada, sus derechos se verán afectados y no recibirá ningún pago. Si anteriormente presentó a tiempo una Solicitud de Exclusión del Grupo de Compradores Demandantes previamente certificado, seguirá excluido de este Acuerdo a menos que decida volver a incluirse, por ejemplo, presentando un Formulario de Reclamación antes del <b>27 de agosto de 2026</b>. Si desea conservar su derecho a demandar o seguir demandando a Google por las reclamaciones de este caso y no desea quedar legalmente vinculado por las decisiones del Tribunal, y no se excluyó del Grupo de Compradores Demandantes de la clase de compradores previamente certificada antes del plazo del 9 de septiembre de 2024, debe excluirse del Acuerdo antes del <b>27 de agosto de 2026</b>. Si permanece en el Acuerdo (es decir, no se excluye), podrá oponerse al mismo, al Plan de Asignación o a la solicitud de honorarios y gastos de abogados y de indemnizaciones por servicios prestados antes del <b>27 de agosto de 2026</b>. Una copia de la Moción de los Abogados de los Demandantes para la Concesión de Honorarios y Gastos de los Abogados y de las Indemnizaciones por Servicios de los Demandantes estará disponible en </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">
                              en un plazo de tres días hábiles tras la presentación de la moción ante el Tribunal el <b>23 de julio de 2026</b>.
                            </span>
                          </p><p class="text-build-content" style="line-height: 20px; margin: 10px 0;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">El Tribunal celebrará una Audiencia de Aprobación Definitiva el <b>1 de octubre de 2026</b>, para considerar si aprueba el Acuerdo y una solicitud de honorarios de abogados de hasta un tercio del Fondo del Acuerdo, gastos de hasta $1,600,000 y compensaciones por servicios de hasta $10,000 para cada Demandante nombrado. La audiencia se celebrará el <b>1 de octubre de 2026, a las 9:00 a.m. PT</b>, en el Tribunal de Distrito de los Estados Unidos para el Distrito Norte de California, Palacio de Justicia de San José, 280 South 1st Street, Sala 1 - Piso 5, San José, CA 95113.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Puede solicitar permiso para que usted o su propio abogado comparezcan e intervengan en la Audiencia de Aprobación Definitiva —a su propio cargo— <b>pero no está obligado a hacerlo</b>. &nbsp;</span></p>
                        </div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#edf6fc" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#edf6fc;background-color:#edf6fc;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#edf6fc;background-color:#edf6fc;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>POR FAVOR, REVISE EL </b></span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/notice"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>AVISO COMPLETO</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><b> QUE SE ENCUENTRA EN EL SITIO WEB DEL ACUERDO,</b></span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">,</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">para obtener información más detallada sobre el Acuerdo, o bien puede ponerse en contacto con el Administrador de Reclamaciones si tiene alguna pregunta:</span></p><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Google Assistant Privacy Settlement</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">(Acuerdo de Privacidad del Asistente de Google)</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">c/o A.B. Data, Ltd.</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">P.O. Box 170500</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Milwaukee, WI 53217</span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" href="mailto:info@GoogleAssistantPrivacyLitigation.com"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px">info@GoogleAssistantPrivacyLitigation.com</span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Teléfono gratuito: 1-877-411-4704</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px 10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 15px 10px 15px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 15px 10px 15px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><b>PRESENTAR UNA RECLAMACIÓN</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">También puede acceder al expediente de este caso a través del sistema de Acceso Público a los Registros Electrónicos Judiciales (Public Access to Court Electronic Records, PACER, por sus siglas en inglés) en </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://ecf.cand.uscourts.gov"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px">https://ecf.cand.uscourts.gov</span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">, o acudiendo a la oficina del Secretario del Tribunal del Tribunal de Distrito de los Estados Unidos para el Distrito Norte de California en cualquiera de las sedes del Tribunal entre las 9:00 a. m. y las 4:00 p. m., de lunes a viernes, excepto los feriados judiciales.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">POR FAVOR, NO LLAME AL TRIBUNAL NI A LA SECRETARÍA DEL TRIBUNAL PARA SOLICITAR INFORMACIÓN SOBRE ESTE ACUERDO.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:13px"><b>POR ORDEN DEL TRIBUNAL DE DISTRITO DE LOS ESTADOS UNIDOS PARA EL DISTRITO NORTE DE CALIFORNIA.</b></span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><![endif]-->


  </div>

</body>
</html>
